export default __webpack_public_path__ + "static/media/resume.78c85e87.pdf";